import { Routes, Route, Navigate } from "react-router-dom";
import { SuperSchooladminSidebar } from "../../Sidebar/superchooladmin-sidebar";
import SuperSchooladminSchools from "../SuperSchooladmindashboard/SuperSchooladminSchools";

export default function SuperSchooladminDashboardRouter() {
  return (
    <Routes>
      <Route path="/" element={<SuperSchooladminSidebar />}>
        <Route index element={<Navigate to="/dashboard/schools" replace />} />
        <Route path="schools" element={<SuperSchooladminSchools />} />
        <Route path="*" element={<Navigate to="/dashboard/schools" replace />} />
      </Route>
    </Routes>
  );
}
